/**
 * Enumeración que representa las diferentes formas de pago.
 * @namespace
 * @property {string} CONTADO - Indica un pago al contado.
 * @property {string} MESES_SIN_INTERESES - Indica un pago a meses sin intereses.
 */
export const FORMA_PAGO = {
  TIPO_CONTADO: 'contado',
  TIPO_MESES_SIN_INTERESES: 'mesesSinIntereses',
  /**
   * Verifica si el tipo de pago proporcionado corresponde a un pago al contado.
   *
   * @param {string} tipoPago - El tipo de pago a verificar.
   * @returns {boolean} Devuelve `true` si el tipo de pago es 'contado', de lo contrario `false`.
   */
  isContado: function (tipoPago) {
    return tipoPago === this.TIPO_CONTADO;
  },

  /**
   * Verifica si el tipo de pago proporcionado corresponde a un pago a meses sin intereses.
   *
   * @param {string} tipoPago - El tipo de pago a verificar.
   * @returns {boolean} Devuelve `true` si el tipo de pago es 'mesesSinIntereses', de lo contrario `false`.
   */
  isMSI: function (tipoPago) {
    return tipoPago === this.TIPO_MESES_SIN_INTERESES;
  },
};
